import getUrlByRole from "./getUrlByRole";
export default function getOptions(productData, getType) {
    const productType = productData?.__typename;
    const isConfigurableProduct = productType === "ConfigurableProduct";
    const callback = (array) => array?.reduce((prev, option) => ({
        ...prev,
        [isConfigurableProduct ? option?.product?.sku : option.id]: getType === "gallery" ? getUrlByRole(option?.product?.media_gallery) : option?.product?.stock_status,
    }), {});
    if (isConfigurableProduct) {
        return getType === "gallery" ? {} : callback(productData?.variants);
    }
    return productData?.items
        ?.map((item) => callback(item?.all_options))
        .reduce((prev, option) => ({
        ...prev,
        ...option,
    }), {});
}
//# sourceMappingURL=getOptions.js.map